<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"><HeaderContent /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <!-- 动态详情 -->
      <div class="dynamic_details" v-html="newContents"></div>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}

.wzStyle {
  p {
    font-size: 16px;
    line-height: 32px;
  }
}
.main_content {
  padding: 0 !important;
  background: #f8fafc;
  .dynamic_details {
    margin: 62px 260px 53px 260px;
    padding: 55px 67px 74px 61px;
    background: #fff;
    text-align: left;
    font-size: initial;
    h1 {
      font-size: 30px;
    }
    p {
      font-size: 16px;
      line-height: 32px;
    }

    div {
      text-align: center;
    }
  }
}
@media only screen and (max-width: 1600px) {
  .main_content {
    .dynamic_details {
      margin: 62px 8% 53px 11.5%;
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";
import imgOne from "@/assets/images/newOne.png";
import imgTwo from "@/assets/images/newTwo.png";
import newTwoImg1 from "@/assets/images/companyDynamics1.png";
import newTwoImg2 from "@/assets/images/dynamicDetail22.jpg";
import newThreeImg1 from "@/assets/images/kaochaweid.png";
import newFourImg from "@/assets/images/fourNews.png";
import newFiveImg from "@/assets/images/newImgBig5.png";
import newSixImg from "@/assets/images/newImgBig6.png";
import newSevenImg from "@/assets/images/tjBig1.png";
import newEightImg from "@/assets/images/tjBig2.png";
import newNineImg from "@/assets/images/tjBig3.png";
import newTenImg from "@/assets/images/tjBig4.png";
import newElevenImg from "@/assets/images/greenJob.png";
import newElwImg from "@/assets/images/newImg9.png";
import newThringImg from "@/assets/images/newImg10.png";
import newForteenImg from "@/assets/images/newImg11.png";
import newImgs1 from "@/assets/images/newImg8.png";
import newImgs2 from "@/assets/images/newImg12.png";
import newImgs3 from "@/assets/images/newImg13.png";

export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  data() {
    return {
      newContents: "",
      newContent: {
        newOne:
          "<h1 style='font-size: 30px;'>永州市城投集团相关领导莅临湖南桅灯考察</h1><p style='margin: 10px 0;font-size: 16px;line-height: 32px;'>2021-09-10</p><div style='text-align: center;'><img style='max-width: 100%' src='" +
          imgOne +
          "' /></div><p>2021年09月10日下午，永州市城投集团党委副书记兼总经理邓铁成、永州市国资委副主任罗有生、永州市城投集团党委副书记兼副总经理郭晓斌等一行领导来我公司视察指导，对于人工智能以及物联网运用领域工作给予高度重视。</p><br /><div style='text-align: center;'><img style='max-width: 100%' src='" +
          imgTwo +
          "' /></div><p style='font-size: 16px;line-height: 32px;'>公司相关负责人李俊总就公司的发展史，桅灯智能科技的核心技术以及相关产品做了详细介绍，并对目前我公司工作的开展情况、取得的成绩做了汇报，得到了各位领导的充分肯定。邓铁成书记对我公司提出了宝贵意见，希望关于人工智能方面多总结成功经验，借鉴区域成功案例，让更多用户了解和受益。</p><br /><p style='font-size: 16px;line-height: 32px;'>湖南桅灯智能科技有限公司对各位领导的到访以及对我公司的肯定表示真挚的感谢。</p><br />",
        newTwo:
          "<h1 style='font-size: 30px;'>进军蓝海市场，WIDEN桅灯智能如何生存？</h1><p class='author' style='margin: 20px 0;'><span>2021/08/11 11:17</span></p><p style='font-size: 16px;line-height: 32px;'>近年来，物联网行业越来越热，随着5G技术的落地与实现，物联网的发展更是达到了新的高度。当前，整个物联网市场都处在急速膨胀当中，参与者众多，行业涵盖广泛，物联网产品涉及内容也十分复杂。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>新的用户需求、新的创新技术和新的品牌巨头都在驱动着物联网行业的发展，在这样激烈的竞争之中，一家物联网创业公司WIDEN桅灯智能于2017年12月成立后也奔入了物联网行业的浪潮之中。WIDEN桅灯智能的主攻领域定位在了“智慧居家”与“智慧城市”之间的“公共空间”，主要面对B端业务，独特的发展定位也令外界对其有所期待。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>但是，在无论是行业巨头还是创业公司都纷纷入局物联网行业胜景之下，WIDEN桅灯智能究竟是能够走出差异化之路，还是被淹没在物联网行业的滚滚巨浪之中呢？答案恐怕还是有待考量。</p><h3 style='margin: 20px 0;'>进军蓝海领域，WIDEN桅灯智能或成炮灰</h3><p style='font-size: 16px;line-height: 32px;'>纵观物联网发展大方向，目前主要物联网智慧建设主要包括两大类别。第一类是城市空间的智慧建设，例如阿里、百度、科大讯飞等企业致力于智慧城市场景；第二类是居家空间的智慧建设，例如华为、美的、小米等企业专注在智能家居场景。</p><p style='font-size: 16px;line-height: 32px;'>而创业公司WIDEN桅灯智能想要在城市和居家之间的公共空间智慧建设之中谋求差异化之路。主攻领域包括例如产业园区、社区、医院、学校等半开放式的公共空间。</p><div style='text-align: center;'><img src='" +
          newTwoImg1 +
          "' /></div><br /><br /><p style='font-size: 16px;line-height: 32px;'> 不难看出，WIDEN桅灯智能想要进军的是一个还没有什么参与者在做的蓝海领域，这也令人十分担忧，这样一家几十人体量的小公司真的能够按照预想突击蓝海领域，走出自己的差异化之路吗？</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>从WIDEN桅灯智能的现状及发展来看，从17年12月成立后直到19年里，整个公司只有一支体量较小的团队一直进行着平台产品的研发工作。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>成立后将近两年的时间里，在产品研发方面WIDEN桅灯智能可以被说是一无所获，2020年之后，也仅仅推出了一个名为CNS智能中枢系统1.0版本的产品，但这一产品也并没有在业内激起太大的水花。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>显然，在半开放的公共空间智慧建设这一蓝海前沿领域，WIDEN桅灯智能的小身材还是难以想期待的一样迸发出巨大的能量。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>这样的结果也不免引人深思，当一个市场完全没有人做的情况下，是不是这个市场不值得去做呢？又或者以目前的科技发展来说，这样的市场恐怕是难以驾驭的呢？无论如何，就目前而言，WIDEN桅灯智能的发展着实令人忧心。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>事实上，受新冠肺炎疫情影响，企业和政府部门都在办公和日常生活中增强了互联网、物联网和数字设备的使用，据悉，即使疫情消退，这种高水平的数字化仍将保持。从长期来看，疫情将加强人们对物联网的依赖。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>这对于各个物联网公司而言，虽然是一个巨大的挑战，但也无疑是发展的良机。例如，进军物联网行业的广和通便秉持着“疫情虽然是危，但危中也有机”的信念，迅速承接了广泛的物联网无线通信模组市场需求，抓住机会，进一步加大新技术、新产品的研发投入，不仅营收大幅上涨，股价也扶摇直上。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>反观WIDEN桅灯智能，在疫情期间的发展就显得十分乏力。且不说在无产品推出之前，大有闭门造车之势，研发的CNS智能中枢系统1.0版本在推出之后更多的方式也只是打包给园区使用或做一些技术支持，没有后期增加更多的技术投入，错过了疫情带给互联网企业的转机，发展呈现出了疲软状态。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>另外，WIDEN桅灯智能给出的定位是一家人工智能视觉识别服务提供商，基于深度学习，研发人脸识别、步态识别、人形识别、物体识别等计算机视觉技术产品，为智慧商业、智慧社区、智慧通行提供全方位AI解决方案。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>然而WIDEN桅灯智能作为一个发展近3年，还获得了3轮融资的的物联网公司，目前却仅仅推出了CNS智能中枢1.0版本这一个产品，功能上也与其定位所说相距甚远，从技术上来看确实水分不少，有言过其实之嫌。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>与国际性跨国大企业和国内大型科技集团的前瞻性及极强的研发能力相比，创业公司自主研发难、技术“失声”是WIDEN桅灯智能可持续发展过程中面临的重大阻碍之一。想要在物联网行业深耕，等待WIDEN桅灯智能还有人才、资金和技术三座大山。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>目前来看，WIDEN桅灯智能所处赛道，没有成熟的企业领跑，作为创业公司在技术研发上面临的困难确实不言而喻。其次，就人才来说，WIDEN桅灯智能目前主要涵盖的是计算机和建筑类的人才，想要继续在人工智能等方面继续深挖的话，仅依靠目前的人才储备还是远远不够。</p>br /><br /><p style='font-size: 16px;line-height: 32px;'>科技迭代升级，行业发展瞬息万变，WIDEN桅灯智能在应对变化，顺势而为上的表现不尽人意。只身投入蓝海领域的WIDEN桅灯智能梦想很大却未能照进现实，公司定位是否恰当，未来发展过程中会不会轮为物联网行业炮灰？不免让人为WIDEN桅灯智能的未来发展捏一把汗。</p><h3 style='margin-top: 30px;'>个人隐私、数据安全，WIDEN桅灯智能发展受阻</h3><br /><br /><p style='font-size: 16px;line-height: 32px;'> “设想一下，早上九点开车上班，进入停车场的同时，车牌识别系统中枢已经提前将电梯停至负一楼，办公室空调也已打开，只等你安心进入办公状态。”这是WIDEN桅灯智能在宣传中写出的未来致力于实现的设想场景。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>从这一场景中可以看到，WIDEN桅灯智能对于万物互联的高追求，但是也仅在这一个小小的设定场景就能看到，平台会访问你的数据库、个人状态，甚至是每天GPS行进的路径和停留地点。这将体现着WIDEN桅灯智能未来发展规划中对于用户个人隐私数据的超高度需求体现的淋漓尽致。</p><br /><br /><div style='text-align: center;'><img src='" +
          newTwoImg2 +
          "'/></div><p style='font-size: 16px;line-height: 32px;'>然而近几年，广大用户对于个人隐私和数据安全问题的重视程度越来越高，越来越多的用户甚至在下载APP时都普遍不愿意轻易赋予手机定位、访问通讯录等等权限。用户们谈数据色变，在各大媒体上广泛发声，物联网时代，求求企业别再“偷”老百姓的数据了。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>海默科技董事长窦剑文提到：“数据的安全和隐私是一个需要一直去研究和解决的问题，它与用户的使用意愿相关，在推广过程中是非常重要的话题，也是从开发、技术的角度要重点考虑的问题。”</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>更何况，不同于阿里、华为这类大企业有广泛的国民接受度，用户对于WIDEN桅灯智能这类新兴创业公司的信任度相对较低，并且其主要投放的公共空间市场对于用户行踪轨迹数据的覆盖面更广，用户的质疑进而导致了依靠用户数据进行互通布局的WIDEN桅灯智能发展难免受阻。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>此外，万科集团执行副总裁张旭曾在研讨会上说：”服务业会涉及很多的隐私，所以需要非常严肃的考虑安全保护措施。当然，哪些数据能采集，哪些不能采集，我想我们要有基本的原则。能够公开、透明、可讨论的数据才可以采集，这是我们对待客户隐私的基本底线。“</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>用户的数据是真实的、相对隐秘的，所以企业内部的网络安全、数据安全、数据访问就需要有非常严格的管理机制和技术手段。但是目前来看，WIDEN桅灯智能并没有对外公布其是否能够严格保证用户的个人隐私和数据安全，这令广大用户忧心忡忡。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>众所周知，物联网行业需要依靠数据进行迭代更近，在为客户提供定制方案时，数据越多，才能越好地个性化针对客户的优化点提供定制化的方案。一旦无法获取用户信任，WIDEN桅灯智能就会面临发展不稳的窘境。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>如何在用户“谈数据色变”的时代进行公共空间智慧建设的物联网布局，是WIDEN桅灯智能面临的迫切问题。无论是用户还是投资方都等待着WIDEN桅灯智能能够公布一个值得信赖的用户数据安全保护机制。</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>如何深耕公共空间的智慧建设，如何应对个人隐私、数据安全问题，目前在蓝海领域挣扎前行的WIDEN桅灯智能是时候冷静思考一下了，在以数据为驱动，依靠用户信赖的物联网行业任凭产品再花式，功能再强大，没有用户，物联网平台终将成为无根之木。</p><br /><br /><h3 style='margin: 10px 0 20px 0;'>结语</h3><p style='font-size: 16px;line-height: 32px;'>物联网行业崛起迅速，滚滚巨浪，各企业擅长领域和发展重点虽然有所差异，但相似领域之间同质化强，竞争压力大，牺牲品众多。每个公司都想要顺风而起，在这样的行业大环境中，想要深耕公共空间智慧建设的WIDEN桅灯智能能够异军突起扶摇直上吗？还是在无人问津的蓝海领域之中逐渐稀释瓦解呢？</p><br /><br /><p style='font-size: 16px;line-height: 32px;'>无论怎么样，物联网都将是下一个推动世界高速发展的重要生产力，公共空间的智慧建设在未来也有一定的应用市场，作为有一定技术基础的WIDEN桅灯智能团队自然不会坐以待毙。期待着WIDEN桅灯智能能够提升技术创新，找到发展之路，为我国物联网建设添砖加瓦，走向光明前途。</p><br /><br />",
        newThree:
          "<h1 style='font-size: 30px;'>柳州市柳北区委书记刘俊等一行领导莅临桅灯智能长沙总部考察</h1><p style='font-size: 16px;line-height: 32px;margin: 10px 0;'>2021-09-14</p><p style='font-size: 16px;line-height: 32px;'>2021年9月14日下午，湖南桅灯智能科技有限公司迎来广西柳州市柳北区委书记刘俊、柳北区委副书记梁敏娟、柳北区委常委、区委办主任钟庆林等一行领导。公司相关负责人龙照凯总热情接待，并陪同领导参观湖南桅灯总部。</p><br /><div style='text-align: center;'><img style='max-width: 100%' src='" +
          newThreeImg1 +
          "' /></div><br /><p style='font-size: 16px;line-height: 32px;'>走进桅灯智能科技有限公司，各位领导首先了解到，这是一家专注公共空间智慧建筑领域运用物联网人工智能技术的科技公司，龙照凯总详细汇报了公司CNS智能中枢产品的运行原理、技术先进性、产品推广现状以及国内市场前景，期间刘书记就产品科技创新以及未来公司发展方向等问题点进行询问，龙照凯总一一解答。</p><br /><p style='font-size: 16px;line-height: 32px;'>最后，刘书记对我公司核心技术领域表示充分的肯定，希望以后能够有合作的机会与家乡企业进行对接，以期实现企业双方及社会效应的共赢。</p><br />",
        newFour:
          "<h1 style='font-size: 30px;'>新疆鄯善县委常委、副县长邹燕娇等一行领导莅临WIDEN考察</h1><p style='font-size: 16px;line-height: 32px;margin: 10px 0;'>2021-09-25</p><p style='font-size: 16px;line-height: 32px;'>2021年9月25日新疆鄯善县委常委、副县长邹燕娇、鄯善县工商局局长李伟、鄯善县文旅局副局长李孟炎等一行领导到我公司进行调研检查工作。</p><br /><div style='text-align: center;'><img style='max-width: 100%' src='" +
          newFourImg +
          "' /></div><br /><p style='font-size: 16px;line-height: 32px;'>桅灯智能欧阳总、龙照凯、李俊、彭彩风等公司领导陪同邹县长等参观了公司展厅并在公司会议室进行座谈会，龙照凯总介绍了公司的基本情况，发展现状及未来规划，详细介绍了公司核心技术CNS智能中枢产品应用于智能园区、智能社区、智能建筑、智能校园、智能交通等领域的智能工程设计。从核心技术自主研发，方案设计到运维实施，从整体构架设计到系统方案解决，我们都展现了丰富的经验，公司立志成为卓越的行业优质服务商与引领者。</p><br /><p style='font-size: 16px;line-height: 32px;'>此次视察调研，考察团对我公司以“政府推动，市场导向，科技支撑”为发展道路，“一切源于创新突破，一切源于用户认可”为经营宗旨，对公司标准化、规范化、专业化的服务体系和良好的企业形象留下了深刻的印象。邹县长等领导对桅灯智能科技有限公司的成长性给予了高度评价，对现有涉及领域及创新项目给予认可。</p><br />",
        newFive:
          "<h1 style='font-size: 30px;'>唐山市丰南区委书记、区政府区长霍强等一行领导莅临湖南桅灯参观指导</h1><p style='font-size: 16px;line-height: 32px;margin: 10px 0;'>2021-10-19</p><p style='font-size: 16px;line-height: 32px;'>2021年10月19日唐山市丰南区委书记、区政府区长霍强、区政府副区长吴帆等一行领导到湖南桅灯智能科技有限公司参观考察。</p><br /><div style='text-align: center;'><img style='max-width: 100%' src='" +
          newFiveImg +
          "' /></div><br /><p style='font-size: 16px;line-height: 32px;'>我公司相关负责人龙照凯总全程陪同讲解，主要从企业简介及成立背景、人才团队支撑、利好政策、产品介绍、核心技术、核心竞争力、市场效应预测等方面向大家分享了桅灯智能科技有限公司投入研发智能产业成立以来的历程。在参观期间，龙总还向前来参观的各位领导介绍了我司主要设备的性能用途及公司不断引进和融合国际先进的深度学习，人工智能等技术，研发出行业领先产品。</p><div style='text-align: center;'><img style='max-width: 100%' src='" +
          newSixImg +
          "' /></div><br /><p style='font-size: 16px;line-height: 32px;'>在观看完我司的视频讲解后，各位领导对桅灯智能的企业整体战略和发展方向表示充分肯定，各位领导对此次参观表示非常满意。</p><br />",
        newSix:
          "<h1 style='font-size: 30px;text-align: center;'>桅灯，团建/心在一起，勇往直前</h1><p style='font-size: 16px;line-height: 32px;margin: 10px 0;text-align: center;'>2021-10-26</p><div class='wzStyle' style='text-align: center;'><p>阳光正好，微风不燥</p><br /><p>正是出游的最好季节</p><br /><p>告别紧张的工作旋律</p><br /><p>踏着微风徐来的步履</p><br /><p>走到户外呼吸清新空气</p><br /><p>在欢声笑语中感受大自然的魅力</p><br /><p>从团队建设中领悟桅灯的协作精神</p><br /></div><div style='text-align: center;'><img style='max-width: 100%' src='" +
          newSevenImg +
          "' /></div><br /><p style='font-size: 16px;line-height: 32px;'>10月26日，活动正式拉开序幕，公司组织拔河比赛，摸石子过河，户外烧烤等一系列活动，员工充分发挥团队协作精神出色的完成一系列的活动，活动场面既激烈如火又温馨和谐，每个活动中员工们都默契配合，都发挥了团队协作精神，尽情挥洒青春的激情。</p><div style='text-align: center;'><img style='max-width: 100%' src='" +
          newEightImg +
          "' /></div><div style='text-align: center;'><img style='max-width: 100%' src='" +
          newNineImg +
          "' /></div><div style='text-align: center;'><img style='max-width: 100%' src='" +
          newTenImg +
          "' /></div><br /><p style='font-size: 16px;line-height: 32px;'>本次团建活动圆满结束，又一轮新的挑战即将开始，公司的伙们将全身心的投入到工作中，重视沟通，配合默契，为桅灯的快速发展贡献力量，铸就桅灯更加辉煌的明天。</p><br />",
        newSeven:
          "<h1 style='font-size: 30px;text-align: center;'>湖南桅灯成为深圳市绿色建筑协会会员单位</h1><p style='font-size: 16px;line-height: 32px;margin: 10px 0;text-align: center;'>2021-12-31</p><div class='wzStyle' style='text-align: left;line-height: 32px;margin-bottom: 10px;'>2021年12月31日，湖南桅灯由深圳市绿色建筑协会正式公示，基于对我司在人工智能及CNS-建筑能耗管理领域的雄厚科研实力和影响力，以及对公司成果转化能力的充分评估和考察，湖南桅灯智能科技有限公司在“深圳市绿色建筑协会第三届理事会监事会第十一次工作会议”上通过成为会员单位的申请。</div><div style='text-align: center;'><img style='max-width: 100%' src='" +
          newElevenImg +
          "' /></div><br /><p style='font-size: 16px;line-height: 32px;'>通过人工智能与绿色环保主题相结合，为绿色生态城市的建设和发展献策献力，用智慧和现代科技让大众的幸福生活在绿色中绽放，湖南桅灯将积极参加各项相关活动，共同分享绿色资讯，汲取绿色养分，畅想绿色未来。</p><br />",
        newEight:
          "<h1 style='font-size: 30px;text-align: center;'>深圳市科技工业园集团董事长何景成等一行领导莅临湖南桅灯参观考察</h1><p style='font-size: 16px;line-height: 32px;margin: 10px 0;text-align: center;'>2022-04-26 10:52</p><div class='wzStyle' style='text-align: left;line-height: 32px;margin-bottom: 10px;'>2022年4月25日下午，深圳市科技工业园集团董事长何景成在湖南桅灯相关负责人龙照凯的陪同下，莅临湖南桅灯智能科技有限公司参观考察。</div><div style='text-align: center;'><img style='max-width: 100%' src='" +
          newElwImg +
          "' /><img style='max-width: 100%' src='" +
          newThringImg +
          "' /><br /><p style='font-size: 16px;line-height: 32px;'>我司领导全程陪同讲解，参观了公司产品展区，详细介绍了公司的发展史，核心技术，产品研发，何总听取了我司负责人对于人工智能化技术的应用成果的汇报，对于我司实现数字化建设，打造云智一体的智能化，绿色建筑，何总给予了高度评价。</p><br /><img style='max-width: 100%' src='" +
          newForteenImg +
          "' /><p style='font-size: 16px;line-height: 32px;'>在观看完我司的视频讲解后，各位领导对桅灯智能的企业整体战略和发展方向表示充分肯定，各位领导对此次参观表示非常满意。</p><br /></div>",
        newNine:
          "<h1 style='font-size: 30px;text-align: center;'>内蒙古通辽市科尔沁市人民政府副区长孟凡辉等一行领导来到湖南桅灯进行参观</h1><p style='font-size: 16px;line-height: 32px;margin: 10px 0;text-align: center;'> 2022-04-28 10:59</p><div class='wzStyle' style='text-align: left;line-height: 32px;margin-bottom: 10px;'>2022年4月27日上午，内蒙古通辽市科尔沁市人民政府副区长孟凡辉等一行领导来到湖南桅灯智能科技有限公司进行参观。我司负责人对来访的领导表示热烈欢迎，并结合企业发展情况，分享了相关经验。</div><div style='text-align: center;'><img style='max-width: 100%' src='" +
          newImgs1 +
          "' /><br /><p style='font-size: 16px;line-height: 32px;'>我司负责人主要从企业简介及成立背景、人才团队支撑、利好政策、产品介绍、市场效益等方面向大家分享了湖南桅灯智能科技投入研发多年来的历程。</p><br /><img style='max-width: 100%' src='" +
          newImgs2 +
          "' /><br /><img style='max-width: 100%' src='" +
          newImgs3 +
          "' /><p style='font-size: 16px;line-height: 32px;'>参观完后，孟区长对于我司现阶段取得的成果给予充分的肯定，也对我们公司提供了一些宝贵经验，希望以后加强交流，促进更多的合作机会。</p><br /></div>",
      },
      newTitle: "",
      newChoose: 1,
      metaData: [
        {
          name: "keyWords",
          content:
            ",桅灯智能,WIDEN,上海桅灯智能科技有限公司,湖南桅灯智能科技有限公司",
        },
        {
          name: "description",
          content:
            "桅灯智能，专注公共空间智慧建筑领域的物联网、人工智能技术，用技术赋能公共空间，桅灯智能CNS智能中枢生态平台涵盖AIoT、智慧物管、智慧资管、智慧能源、智慧安防、智慧通行、数字孪生等模块支撑全场景业务。",
        },
      ],
    };
  },
  metaInfo() {
    return {
      title: this.newTitle,
      meta: this.metaData,
    };
  },
  mounted() {
    this.newChoose = this.$route.query.uid;

    if (this.newChoose == 1) {
      this.newContents = this.newContent.newOne;
    } else if (this.newChoose == 2) {
      this.newContents = this.newContent.newTwo;
    } else if (this.newChoose == 3) {
      this.newContents = this.newContent.newThree;
    } else if (this.newChoose == 4) {
      this.newContents = this.newContent.newFour;
    } else if (this.newChoose == 5) {
      this.newContents = this.newContent.newFive;
    } else if (this.newChoose == 6) {
      this.newContents = this.newContent.newSix;
    } else if (this.newChoose == 7) {
      this.newContents = this.newContent.newSeven;
    } else if (this.newChoose == 8) {
      this.newContents = this.newContent.newEight;
    } else if (this.newChoose == 9) {
      this.newContents = this.newContent.newNine;
    }
  },
  created() {
    this.initData();
  },
  watch: {},
  methods: {
    initData() {
      this.newTitle = this.$route.query.content + "-WIDEN桅灯智能";
      this.metaData = [
        {
          name: "keyWords",
          content:
            this.newTitle +
            ",桅灯智能,WIDEN,上海桅灯智能科技有限公司,湖南桅灯智能科技有限公司",
        },
        {
          name: "description",
          content:
            "桅灯智能，专注公共空间智慧建筑领域的物联网、人工智能技术，用技术赋能公共空间，桅灯智能CNS智能中枢生态平台涵盖AIoT、智慧物管、智慧资管、智慧能源、智慧安防、智慧通行、数字孪生等模块支撑全场景业务。",
        },
      ];
    },
  },
  computed: {},
};
</script>